<template>
    <Layout>
        <div class="row mt-2">
            <div class="col-12">
                <h6 class="page-title font-18">Trainee Follow Up</h6>
            </div>
        </div>
        <div class="bg-white rounded box-shadow p-3" v-if="Object.keys(followup).length !== 0">
                <div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Trainee Name</strong>
                                    <router-link :to="{name: 'traineeView', params: { trainee_id: followup.trainee.id }}"
                                                 tag="a" target="_blank">{{ followup.trainee.rep_name ?  followup.trainee.rep_name : followup.trainee.name }}
                                    </router-link>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Trainee Fathers Name</strong>
                                    {{ followup.trainee.rep_father_husband_name ?  followup.trainee.rep_father_husband_name : followup.trainee.father_husband_name }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Mobile</strong>
                                    {{ followup.trainee.mobile }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="followup.trade_use == null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.1 Present Monthly Income</strong>
                                    {{ followup.present_monthly_income }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.2a Family Monthly Income</strong>
                                    {{ followup.family_monthly_income }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.2b Income From Training Trade</strong>
                                    {{ followup.income_from_training_trade }}
                                </p>
                            </div>
                        </div>

                    </div>
                    <div v-if="followup.trade_use == null" class="row">
                      <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                          <p class="media-body pb-2 mb-0 medium lh-150">
                            <strong class="d-block text-dark pb-1">4.3 Current Monthly Expenses of Family</strong>
                            {{ followup.current_family_monthly_expense }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div v-if="followup.trade_use != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.1 Past Monthly Income</strong>
                                    {{ followup.current_family_monthly_expense }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.2 Present Monthly Income</strong>
                                    {{ followup.present_monthly_income }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.3 Family Monthly Income</strong>
                                    {{ followup.family_monthly_income }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Desi Murgi</strong>
                                    {{ followup.followup_income_source.desi_murgi ? followup.followup_income_source.desi_murgi : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Sonali Murgi</strong>
                                    {{ followup.followup_income_source.sonali_murgi ?  followup.followup_income_source.sonali_murgi : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Broiler</strong>
                                    {{ followup.followup_income_source.broiler ?  followup.followup_income_source.broiler : 0 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Cockrell</strong>
                                    {{ followup.followup_income_source.cockrell  ?  followup.followup_income_source.cockrell : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Tarki</strong>
                                    {{ followup.followup_income_source.tarki ?  followup.followup_income_source.tarki : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Hass</strong>
                                    {{ followup.followup_income_source.hass ?  followup.followup_income_source.hass : 0 }}
                                </p>
                            </div>
                        </div>

                    </div>
                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Raj Hass</strong>
                                    {{ followup.followup_income_source.raj_hass ? followup.followup_income_source.raj_hass : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Kabutor</strong>
                                    {{ followup.followup_income_source.kabutor ? followup.followup_income_source.kabutor : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Goru</strong>
                                    {{ followup.followup_income_source.goru ? followup.followup_income_source.goru : 0 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Ghabi</strong>
                                    {{ followup.followup_income_source.ghabi ? followup.followup_income_source.ghabi : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Chagol</strong>
                                    {{ followup.followup_income_source.chagol ? followup.followup_income_source.chagol : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Bhera</strong>
                                    {{ followup.followup_income_source.bhera ? followup.followup_income_source.bhera : 0 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Buffalo</strong>
                                    {{ followup.followup_income_source.buffalo ? followup.followup_income_source.buffalo : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Pukor</strong>
                                    {{ followup.followup_income_source.pukor ? followup.followup_income_source.pukor : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Computer</strong>
                                    {{ followup.followup_income_source.computer ? followup.followup_income_source.computer : 0 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Sewing</strong>
                                    {{ followup.followup_income_source.sewing ? followup.followup_income_source.sewing : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Welding</strong>
                                    {{ followup.followup_income_source.welding ? followup.followup_income_source.welding : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Led</strong>
                                    {{ followup.followup_income_source.led ? followup.followup_income_source.led : 0 }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="followup.followup_income_source != null" class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Dukan</strong>
                                    {{ followup.followup_income_source.dukan ? followup.followup_income_source.dukan : 0 }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Others</strong>
                                    {{ followup.followup_income_source.others ? followup.followup_income_source.others : 0 }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Income Source</strong>
                                    <span v-for="income_source in followup.income_sources" :key="income_source.id">
                                    {{ income_source.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">5. Training Trade</strong>
                                    <span v-for="training_trade in followup.training_trades" :key="training_trade.id">
                                    {{ training_trade.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">6.1 Are You Jobholder?</strong>
                                    <span v-if="followup.is_job_holder == 1">Yes</span>
                                    <span v-if="followup.is_job_holder == 0">No</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Job Description</strong>
                                    {{ followup.job_description }}
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">3.1 Past Occupation</strong>
                                    {{ followup.past_occupation ? followup.past_occupation.desc : ''}}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">{{ followup.trade_use != null ? '3.2' : '3.1' }} Present Occupation</strong>
                                    {{ followup.present_occupation.desc }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.1 Past Monthly Income</strong>
                                    {{ followup.past_monthly_income }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.2 Present Monthly Income</strong>
                                    {{ followup.present_monthly_income }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">4.3 Family Income</strong>
                                    {{ followup.family_monthly_income }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Income Source</strong>
                                    <span v-for="income_source in followup.income_sources" :key="income_source.id">
                                    {{ income_source.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">5. Training Trade</strong>
                                    <span v-for="training_trade in followup.training_trades" :key="training_trade.id">
                                    {{ training_trade.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">6.1 Are You Jobholder?</strong>
                                    <span v-if="followup.is_job_holder == 1">Yes</span>
                                    <span v-if="followup.is_job_holder == 0">No</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Job Description</strong>
                                    {{ followup.job_description }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">6.2 Any Business?</strong>
                                    <span v-if="followup.doing_business == 1">Yes</span>
                                    <span v-if="followup.doing_business == 0">No</span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">6.3 Business Types</strong>
                                    <span v-for="business_type in followup.business_types" :key="business_type.id">
                                    {{ business_type.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">7. Money Source</strong>
                                    <span v-for="money_source in followup.money_sources" :key="money_source.id">
                                    {{ money_source.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">8. Businesses</strong>
                                    <span v-for="business in followup.businesses" :key="business.id">
                                    {{ business.desc }} <br>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">9. Someone else has seen inspired you</strong>
                                    {{ followup.is_inspire }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">9. Are you receiving any service from the government office? </strong>
                                    <span v-if="followup.govt_help == 1">Yes</span>
                                    <span v-if="followup.govt_help == 0">No</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Govt Help Description</strong>
                                    {{ followup.govt_help_description }}
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">10. Have you ever done any <span v-if="followup.training_trades.length > 0 ">{{followup['training_trades'][0]['desc'] | lowercase}}</span> using advanced technology??</strong>
                                    <span v-if="followup.govt_help == 1">Yes</span>
                                    <span v-if="followup.govt_help == 0">No</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">11. How is your current financial situation?  </strong>
                                    <span v-if="followup.is_financially_improvement == 0">Too much</span>
                                    <span v-if="followup.is_financially_improvement == 1">More</span>
                                    <span v-if="followup.is_financially_improvement == 2">Roughly</span>
                                    <span v-if="followup.is_financially_improvement == 3">No</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">12. At present, your social status has increased?</strong>
                                    <span v-if="followup.is_society_respect == 0">Too much</span>
                                    <span v-if="followup.is_society_respect == 1">More</span>
                                    <span v-if="followup.is_society_respect == 2">Roughly</span>
                                    <span v-if="followup.is_society_respect == 3">No</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Survey Date </strong>
                                    {{ followup.survey_conducted_date }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">10. Are you receiving any service from the government office? </strong>
                                    <span v-if="followup.govt_help == 1">Yes</span>
                                    <span v-if="followup.govt_help == 0">No</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Govt Help Description</strong>
                                    {{ followup.govt_help_description }}
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use != null"  class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">11. How have you benefited from the training?</strong>
                                    <span v-if="followup.is_technology_use == 0">Too much</span>
                                    <span v-if="followup.is_technology_use == 1">More</span>
                                    <span v-if="followup.is_technology_use == 2">Roughly</span>
                                    <span v-if="followup.is_technology_use == 3">No</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="followup.trade_use != null"  class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">12. Has there been any benefit to using advanced technology?</strong>
                                    <span v-if="followup.is_technology_use == 0">Too much</span>
                                    <span v-if="followup.is_technology_use == 1">More</span>
                                    <span v-if="followup.is_technology_use == 2">Roughly</span>
                                    <span v-if="followup.is_technology_use == 3">No</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">13. How much have you benefited financially from training?  </strong>
                                    <span v-if="followup.is_financially_improvement == 0">Too much</span>
                                    <span v-if="followup.is_financially_improvement == 1">More</span>
                                    <span v-if="followup.is_financially_improvement == 2">Roughly</span>
                                    <span v-if="followup.is_financially_improvement == 3">No</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">14. At present, your social status has increased?</strong>
                                    <span v-if="followup.is_society_respect == 0">Too much</span>
                                    <span v-if="followup.is_society_respect == 1">More</span>
                                    <span v-if="followup.is_society_respect == 2">Roughly</span>
                                    <span v-if="followup.is_society_respect == 3">No</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div v-if="followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Survey Date </strong>
                                    {{ followup.survey_conducted_date }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Information Provided By</strong>
                                    {{ followup.survey_providers_by }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-lg-4">
                            <div class="media text-muted">
                                <p class="media-body pb-2 mb-0 medium lh-150">
                                    <strong class="d-block text-dark pb-1">Information Provided Date </strong>
                                    {{ followup.survey_providers_date }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                        <!--                    <div class="col-md-6 col-sm-6 col-lg-4">-->
                        <!--                        <div class="media text-muted">-->
                        <!--                            <p class="media-body pb-2 mb-0 medium lh-150">-->
                        <!--                                <strong class="d-block text-dark pb-1">Survey Conducted By</strong>-->
                        <!--                                {{ followupsurvey_conducted.name }}-->
                        <!--                            </p>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                    </div>
                </div>
         </div>
    </Layout>
</template>

<script>
    import http from "@state/http";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";

    export default {
        components: {Layout, PageHeader },
        data() {
            return {
                flag: false,
                followup: {},
            };
        },


        mounted() {
            this.getTraineeFollowup();
        },
        methods: {
            async getTraineeFollowup() {
                let followup_id = this.$route.params.followup_id;
                await http.get("api/followup/view/" + followup_id)
                    .then(resource => {
                        this.followup = resource.data.followup
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        },
        filters: {
            lowercase: function(v) {
                return v.toLowerCase();
            }
        }
    };
</script>

<style scoped>

</style>
